import { Back, TweenMax } from 'gsap';
import { GameAudio } from '../../Config/Audio';
import { getGameSize } from '../../Config/Levels';
import Core from '../../Core/Core';
import { HudActions, HudEmitter } from '../../Managers/Hud/HudEmitter';
import { Popup } from '../../Managers/Popups';
import { ShareableMoments } from '../../SDK/SDKmessages';
import SoundManager from '../../Sound/SoundManager';
import { createOutlineText, scaleToFit } from '../../Utils/Utils';
import { Animation } from '../Animations/Animation';
import { UIButton } from '../Shared/Buttons/UIButton';

export class PopupHeader extends PIXI.Sprite {
    public readonly popupType: Popup;
    public readonly headerText: PIXI.Text;
    public readonly closeButton: UIButton;
    private readonly shareType: ShareableMoments;
    private readonly targetScale: number;

    public get width() {
        return this.texture.width * this.targetScale;
    }

    public get height() {
        return this.texture.height * this.targetScale;
    }

    constructor(
        headerTextKey: string,
        popupType: Popup,
        targetScale: number = 1.15,
        shareType?: ShareableMoments
    ) {
        super();

        this.shareType = shareType;
        const gameSize = getGameSize();
        this.targetScale = 1;
        this.texture = PIXI.utils.TextureCache['commonui/header'];
        this.anchor.set(0.5);
        this.x = gameSize.gameWidth / 2;
        this.y = this.height * 0.35;

        const headerText = createOutlineText(
            Core.local.getText(headerTextKey),
            new PIXI.Rectangle(0, 0, this.width * 0.8, this.height * 0.4),
            'Baloo',
            42,
            45,
            0xffffff,
            0x991f33
        );
        const scale = scaleToFit(
            headerText.width,
            headerText.height,
            this.width * 0.45,
            this.height * 0.4
        );
        headerText.scale.set(scale < 1 ? scale : 1);
        this.headerText = headerText;
        const closeButton = new UIButton('commonui/button-close-orange');

        closeButton.x = this.width * 0.33;
        closeButton.y = -closeButton.height * 0.05;
        closeButton.once('trigger', this.handleCloseBtn.bind(this));
        this.closeButton = closeButton;
        this.popupType = popupType;
        this.targetScale = targetScale;
        this.scale.set(0.2, 1);
        //@ts-ignore
        this.addChild(headerText, closeButton);
    }

    public async tweenIn(duration: number = 0.4): Promise<void> {
        const animation = new Animation({});
        animation.add(() => {
            SoundManager.playSound(GameAudio.WHOOSH_IN);
        });
        animation.add(
            TweenMax.to(this, duration, {
                alpha: 1,
            })
        );
        animation.addToLast(
            TweenMax.to(this.scale, duration, {
                x: this.targetScale,
                y: this.targetScale,
                ease: Back.easeOut,
            })
        );

        await animation.play();
    }

    public tweenOut(...args: any): any {
        SoundManager.playSound(GameAudio.WHOOSH_OUT);
    }

    protected handleCloseBtn() {
        HudEmitter.instance.emit(HudActions.CLOSE_POPUP, this.popupType, -1, [
            'close',
            this.shareType,
        ]);
        this.closeButton.interactive = false;
    }
}
